(function () {
  // MNR-705: Steuert das Laden des Klaviyo-Onsite-Loaders (klaviyo.js + Stub) über die Einwilligung.
  // - Liegt Klaviyo-Consent (Usercentrics) vor → klaviyo.js SEITENWEIT laden (Tracking/Popups/Forms).
  // - Kein Consent + Seite hat eine Embed-Form → Hinweis + „Einwilligen"-Button (analog octane/typeform),
  //   der den Klaviyo-Consent in Usercentrics setzt (= identisch zum Banner) und dann lädt.
  // - Kein Consent + keine Form → nichts (kein IP-Leak); lädt automatisch, sobald Consent erteilt wird.
  // company_id + Popup-Form-IDs kommen per data-Attribut (pro Umgebung/Markt aufgelöst in klaviyo-consent.liquid).
  const scriptEl = document.currentScript || document.querySelector('script[src*="klaviyo-consent"]');
  const COMPANY_ID = scriptEl && scriptEl.getAttribute('data-company-id');

  if (!COMPANY_ID) return;

  const POPUP_MOBILE = (scriptEl && scriptEl.getAttribute('data-popup-mobile')) || '';
  const POPUP_DESKTOP = (scriptEl && scriptEl.getAttribute('data-popup-desktop')) || '';
  const POPUP_BREAKPOINT = parseInt((scriptEl && scriptEl.getAttribute('data-popup-breakpoint')) || '750', 10);
  const PV_KEY = 'shop_page_views';
  const POPUP_SHOWN_KEY = 'klaviyo_popup_shown';

  // sessionStorage kann blockiert sein (Privacy-Modus/Sandbox) — nie ungeschützt zugreifen,
  // sonst würde das ganze Script werfen und klaviyo.js/der Hinweis nie laden.
  function safeGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function safeSet(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (e) { /* Storage blockiert — ignorieren */ }
  }

  const pageViews = (parseInt(safeGet(PV_KEY) || '0', 10) || 0) + 1;
  safeSet(PV_KEY, String(pageViews));

  let popupTriggered = false;

  function loadKlaviyo() {
    // Nicht doppelt laden: klaviyo.js schon da (z.B. PDP-Loader) oder Tag existiert bereits.
    if (window.klaviyo || document.querySelector('script[src*="static.klaviyo.com/onsite/js"]')) return;

    window._klOnsite = window._klOnsite || [];
    try {
      window.klaviyo = new Proxy({}, { get: function (n, i) { return "push" === i ? function () { var n; (n = window._klOnsite).push.apply(n, arguments) } : function () { for (var n = arguments.length, o = new Array(n), w = 0; w < n; w++) o[w] = arguments[w]; var t = "function" == typeof o[o.length - 1] ? o.pop() : void 0, e = new Promise((function (n) { window._klOnsite.push([i].concat(o, [function (i) { t && t(i), n(i) }])) })); return e } } });
    } catch (n) {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push = function () { var n; (n = window._klOnsite).push.apply(n, arguments) };
    }

    const script = document.createElement('script');
    script.async = true;
    // Bei Ladefehler (Adblocker/Netz): Tag + Stub entfernen, damit ein späteres UC_CONSENT neu laden kann.
    script.onerror = function () {
      script.remove();
      try { delete window.klaviyo; } catch (e) { window.klaviyo = undefined; }
    };
    script.src = 'https://static.klaviyo.com/onsite/js/' + COMPANY_ID + '/klaviyo.js?company_id=' + COMPANY_ID;
    document.body.appendChild(script);
  }

  function removePlaceholders() {
    document.querySelectorAll('.klaviyo-consent-placeholder').forEach((el) => el.remove());
  }

  // Vor Einwilligung: EINEN Hinweis + „Einwilligen"-Button vor der ersten Embed-Form einsetzen.
  // Nicht anzeigen, wenn klaviyo.js schon geladen ist (z.B. PDP) — dann rendert/hydriert Klaviyo selbst.
  function showConsentPlaceholder() {
    if (window.klaviyo || document.querySelector('script[src*="static.klaviyo.com/onsite/js"]')) return;
    const tpl = document.getElementById('klaviyo-consent-template');
    if (!tpl) return;
    if (document.querySelector('.klaviyo-consent-placeholder')) return;
    const form = document.querySelector('[class*="klaviyo-form-"]');
    if (!form) return;
    const node = tpl.content.cloneNode(true);
    const btn = node.querySelector('.klaviyo-consent-accept');
    if (btn) btn.addEventListener('click', acceptAndLoad);
    form.parentNode.insertBefore(node, form);
  }

  async function getKlaviyoService() {
    if (typeof UC_UI === 'undefined' || !UC_UI.getServicesBaseInfo) return null;
    try {
      const allServices = await UC_UI.getServicesBaseInfo();
      for (const s of allServices) {
        if ((s.name || '').toLowerCase().includes('klaviyo')) return s;
      }
      return null;
    } catch (e) {
      console.warn('Klaviyo consent: UC_UI.getServicesBaseInfo() failed:', e);
      return null;
    }
  }

  function hasConsent(service) {
    return service && service.consent && service.consent.status === true;
  }

  // Popup custom-getriggert öffnen (Forms in Klaviyo stehen auf „Only on a custom trigger").
  // Nur mit Consent (aus checkConsent), ab der 2. Seite/Session, Desktop-/Mobile-Form je Viewport.
  function maybeOpenPopup() {
    if (popupTriggered) return;
    if (!POPUP_MOBILE && !POPUP_DESKTOP) return;
    if (safeGet(POPUP_SHOWN_KEY)) return;
    if (pageViews < 2) return;
    // Kein Popup, wenn die Seite bereits eine andere Klaviyo-Form (Embed) enthält.
    if (document.querySelector('[class*="klaviyo-form-"]')) return;
    const isDesktop = window.matchMedia('(min-width: ' + POPUP_BREAKPOINT + 'px)').matches;
    const id = (isDesktop ? POPUP_DESKTOP : POPUP_MOBILE) || POPUP_MOBILE || POPUP_DESKTOP;
    if (!id) return;
    popupTriggered = true;

    // „gezeigt" erst markieren, wenn Klaviyo die Form wirklich öffnet — sonst würde ein
    // fehlgeschlagener Load/Trigger das Popup für die Session unterdrücken, ohne es je zu zeigen.
    window.addEventListener('klaviyoForms', function onOpen(e) {
      if (e && e.detail && e.detail.type === 'open' && String(e.detail.formId) === String(id)) {
        safeSet(POPUP_SHOWN_KEY, '1');
        window.removeEventListener('klaviyoForms', onOpen);
      }
    });

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', id]);
  }

  // Klick auf „Einwilligen": Klaviyo-Service in Usercentrics zustimmen, persistieren, dann laden.
  async function acceptAndLoad() {
    const service = await getKlaviyoService();
    if (service && typeof UC_UI !== 'undefined' && typeof UC_UI.acceptService === 'function') {
      UC_UI.acceptService(service.id);
      if (window.__ucCmp && window.__ucCmp.saveConsents) {
        await window.__ucCmp.saveConsents();
      }
    }
    removePlaceholders();
    loadKlaviyo();
  }

  async function checkConsent() {
    const service = await getKlaviyoService();
    if (hasConsent(service)) {
      removePlaceholders();
      loadKlaviyo();
      maybeOpenPopup();
      return true;
    }
    return false;
  }

  async function init() {
    // Consent vorhanden → seitenweit laden (unabhängig davon, ob eine Form da ist).
    if (await checkConsent()) return;
    // Kein Consent: nur auf Form-Seiten den Hinweis + „Einwilligen"-Button zeigen.
    if (document.querySelector('[class*="klaviyo-form-"]')) {
      showConsentPlaceholder();
    }
    // Lädt, sobald Consent erteilt wird (Banner oder Inline-Button).
    window.addEventListener('UC_CONSENT', checkConsent);
  }

  if (typeof UC_UI !== 'undefined' && UC_UI.isInitialized && UC_UI.isInitialized()) {
    init();
  } else {
    window.addEventListener('UC_UI_INITIALIZED', init);
  }
})();
